var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M2 8v2H0V8h2zM1 0c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1z"
  })));
}
export default SvgWarn;